export * as tooltipStyleConfigs from './style-configs';
export { Tooltip } from './tooltip';
export type { TooltipProps } from './types';
